export enum TOAST_TYPES {
  SUCCESS = "success",
  ERROR = "error",
  DEFAULT = "default",
}
